import React from 'react';

export default function AnalyticsConsentBanner({ onConsentChange }) {
  const [isOpen, setIsOpen] = React.useState(true);

  const handleAccept = () => {
    setIsOpen(false);
    onConsentChange('granted');
  };

  const handleDecline = () => {
    setIsOpen(false);
    onConsentChange('declined');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center pointer-events-none pb-4 sm:pb-8 px-4 sm:px-6 lg:px-8">
      <div className="pointer-events-auto w-full max-w-sm sm:max-w-md bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden">
        <div className="p-4 sm:p-6">
          <div className="flex items-start gap-3 sm:gap-4">
            <div className="flex-shrink-0 mt-0.5 sm:mt-0">
              <i className="fas fa-shield-halved text-blue-600 text-xl sm:text-2xl"></i>
            </div>
            <div>
              <h3 className="text-base sm:text-lg font-bold text-gray-900 leading-tight">Analytics &amp; Usage Cookies</h3>
              <p className="text-xs sm:text-sm text-gray-600 mt-1 sm:mt-2 leading-relaxed">
                We use first-party analytics to understand how visitors use the marketplace,
                improve product discovery, and measure engagement. No personal data,
                passwords, or payment information is collected. You can change your
                preference at any time.
              </p>
            </div>
          </div>
        </div>
        <div className="p-4 sm:p-6 border-t border-gray-100 bg-gray-50 flex flex-col sm:flex-row justify-end sm:justify-end gap-3 sm:gap-4">
          <button
            onClick={handleDecline}
            className="px-4 py-2 sm:px-5 sm:py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors w-full sm:w-auto"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-2 sm:px-5 sm:py-2.5 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors w-full sm:w-auto"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
